import React from "react";
/* eslint-disable */
import {
  Box, Card, Grid, CardContent, Divider, CardHeader,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';
import Chip from '@material-ui/core/Chip';


export default class ComponentToPrint extends React.Component {

  render() {
    const productData = this.props.purchasePrice;
    const data = this.props.searchData;
    const totalValues = this.props.totalValues;

    return (
      <div align='left' style={{ padding: '15px' }}>
        <h3><center><u>FCC Purchase Price Variation Report</u></center></h3>
        <div >&nbsp;</div>        
        <div>&nbsp;</div>
        <Box minWidth={1200}>
        <TableContainer style={{ marginLeft: '5px', transform: 'scale(0.95)', transformOrigin: 'top left' }}>
        <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align={'left'}>Date</TableCell>
                  <TableCell align={'left'}>SKU Code</TableCell>
                  <TableCell align={'left'}>SKU</TableCell>
                  <TableCell align={'left'}>FCC</TableCell>
                  <TableCell align={'right'}>Realized Price</TableCell>
                  <TableCell align={'right'}>Savings Per kg</TableCell>
                  <TableCell align={'right'}>Volume(kg)</TableCell>
                  <TableCell align={'right'}>Saving(Rs)</TableCell>

                </TableRow>
              </TableHead>
              <TableBody>
                {productData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell >
                      {new Date(row.orderDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.skuCode}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.sku}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.factoryName}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.realizedPrice == 0 ? "-" : parseFloat(row.realizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.savingQty == 0 ? "-" : parseFloat(row.savingQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.acceptedQuantity == 0 ? "-" : parseFloat(row.acceptedQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.totalSaving == 0 ? "-" : parseFloat(row.totalSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableRow>
                <TableCell align="center" colSpan={6} style={{ fontWeight: "bold" }}>Total</TableCell>
                <TableCell align="right" style={{ fontWeight: "bold" }}>
                  {(totalValues.totalAcceptedQuantity === 0 || totalValues.totalAcceptedQuantity === "-")
                    ? '-'
                    : parseFloat(totalValues.totalAcceptedQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
                <TableCell align="right" style={{ fontWeight: "bold" }}>
                  {(totalValues.totalTotalSaving === "-" || totalValues.totalTotalSaving === 0)
                    ? '-'
                    : parseFloat(totalValues.totalTotalSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>

              </TableRow>
            </Table>
          </TableContainer>
        </Box>
      </div>

    );
  }
}
